import {NGSIResult} from './ngsi-result';

export class PaginatedNgsiResults {

  constructor(public results: NGSIResult[], public cursorBefore?: string, public cursorAfter?: string) {
  }
}

